<template>
  <div class="vsm-filter-chips" :class="'vsm-filter-chips--' + size">
    <span
      class="vsm-chip vsm-chip-clickable total"
      :class="{ 'vsm-chip-selected': totalSelected }"
      @click="$emit('clear-filters')"
    >{{ totalLabel }}</span>
    <slot />
    <slot name="extras" />
    <b-form-input
      v-if="showSearch"
      class="vsm-filter-search"
      :value="searchFilter"
      @input="$emit('update:searchFilter', $event)"
      :placeholder="searchPlaceholder"
    />
    <span v-if="$slots.actions" class="vsm-filter-actions">
      <slot name="actions" />
    </span>
  </div>
</template>

<script>
export default {
  name: 'vsm-mobile-filter-chips',

  props: {
    itemsCount: { type: Number, default: 0 },
    totalCount: { type: Number, default: 0 },
    totalSelected: { type: Boolean, default: false },
    totalFormat: { type: String, default: 'slash' },
    showSearch: { type: Boolean, default: true },
    searchFilter: { type: String, default: '' },
    searchPlaceholder: { type: String, default: 'filter by keyword' },
    size: {
      type: String,
      default: 'md',
      validator: (v) => ['sm', 'md', 'lg'].includes(v),
    },
  },

  computed: {
    totalLabel() {
      if (this.totalFormat === 'of') {
        return `${this.itemsCount} of ${this.totalCount}`
      }
      return `${this.itemsCount}/${this.totalCount}`
    },
  },
}
</script>
